import {
  UPDATE_IN_APP_MESSAGES,
  BLOCK_IN_APP_MESSAGES_BANNER,
  UPDATE_CART_SIZE,
} from 'app/common/constants/action-types';

const INITIAL_STATE = {
  banner: null,
  cartSize: 0,
};

function iamReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case UPDATE_IN_APP_MESSAGES:
      return {
        ...state,
        banner: action.banner,
      };
    case BLOCK_IN_APP_MESSAGES_BANNER:
      return {
        ...state,
        banner: null,
      };
    case UPDATE_CART_SIZE:
      return {
        ...state,
        cartSize: action.cartSize || 0,
      };
    default:
      return state;
  }
}

export default iamReducer;
